import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es7.array.flat-map.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// eslint-disable-next-line
import { fromPromise, concat } from 'apollo-link';
import { onError } from 'apollo-link-error';
import { createUploadLink } from 'apollo-upload-client';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import schema from './apollo-schema.json';
import USE_MARKETPLACE from '~/const/marketplace';
import logout from '~/helpers/logout-helper';
import refreshAppShopTokenQuery from '~/graphql/refreshAppShop.gql';
var fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: schema
});
export default function (_ref) {
  var store = _ref.store,
      req = _ref.req,
      app = _ref.app;

  var _ref2 = req || {},
      _ref2$header = _ref2.header,
      header = _ref2$header === void 0 ? {} : _ref2$header;

  var _store$getters$shared = store.getters['sharedEnv/getSharedEnv'],
      graphqlExternal = _store$getters$shared.graphqlExternal,
      graphqlInternal = _store$getters$shared.graphqlInternal,
      graphqlShopInternal = _store$getters$shared.graphqlShopInternal,
      graphqlShopExternal = _store$getters$shared.graphqlShopExternal,
      appShopUrl = _store$getters$shared.appShopUrl;
  var locale = store.getters['i18n/locale'];
  var useCatalogv1 = store.$cookies.get('usecatalogv1');
  var useStsAuth = 1; // store.$cookies.get('useStsAuth');

  var displayMkpProducts = USE_MARKETPLACE({
    locale: locale,
    $cookies: store.$cookies
  });
  var shop = store.$cookies.get('MDM_TOGGLE_SHOP');
  var httpEndpoint = process.browser ? graphqlExternal : graphqlInternal;
  if (shop) httpEndpoint = process.browser ? graphqlShopExternal : graphqlShopInternal;
  var xMdM = Object.entries(header).filter(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        key = _ref4[0];

    return /^x-mdm-/i.test(key);
  }).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    acc[key] = value;
    return acc;
  }, {});
  var httpLink = createUploadLink({
    uri: httpEndpoint,
    credentials: 'include',
    headers: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, xMdM), header['correlation-id'] && {
      'correlation-id': header['correlation-id']
    }), header['mdm-client-ip'] && {
      'mdm-client-ip': header['mdm-client-ip']
    }), {
      'Ws-Cat-Version': useCatalogv1 ? 1 : 2
    }), displayMkpProducts && {
      'Source-Mkp-Products': 1
    }), useStsAuth && {
      'sts-auth': 1
    }), {}, {
      'Accept-Language': locale.iso
    })
  });
  var isRefreshing = false;
  var pendingRequests = [];

  var resolvePendingRequests = function resolvePendingRequests() {
    pendingRequests.map(function (callback) {
      return callback();
    });
    pendingRequests = [];
  };

  var errorLink = onError(function (_ref7) {
    var graphQLErrors = _ref7.graphQLErrors,
        operation = _ref7.operation,
        forward = _ref7.forward;

    if (graphQLErrors && graphQLErrors.some(function (_ref8) {
      var extensions = _ref8.extensions;
      return extensions.code === 'UNAUTHENTICATED_EMPLOYEE';
    })) {
      if (isRefreshing) {
        return fromPromise(new Promise(function (resolve) {
          pendingRequests.push(function () {
            return resolve();
          });
        })).flatMap(function () {
          return forward(operation);
        });
      }

      isRefreshing = true;
      return fromPromise(app.apolloProvider.defaultClient.mutate({
        mutation: refreshAppShopTokenQuery
      }).then(function () {
        if (!store.$cookies.get('MDM_SELLER_TOKEN')) {
          throw new Error('Failed to refresh seller access token.');
        }

        resolvePendingRequests();
        isRefreshing = false;
        return true;
      }).catch(function (err) {
        console.log(err);
        pendingRequests = [];
        logout();
        window.location.href = "".concat(appShopUrl, "?sessionExpired=true");
      })).filter(function (value) {
        return Boolean(value);
      }).flatMap(function () {
        return forward(operation);
      });
    }

    return null;
  });
  return {
    link: concat(errorLink, httpLink),
    cache: new InMemoryCache({
      fragmentMatcher: fragmentMatcher
    }),
    defaultHttpLink: false
  };
}